import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';

import MessageThreadList from '../MessageThreadList';
import MessageForm from '../MessageForm';
import MessageThreadActions from '../MessageThreadActions';

import s from './MessageThreadContainer.css';


export default class MessageThreadContainer extends Component {
  static propTypes = {
    authenticatedPreferences: object,
    closeAlertDialog: func,
    forwardMessage: func,
    handleUpdateMessageThread: func,
    isLoadingForward: bool,
    isLoadingReply: bool,
    isLoadingSendNew: bool,
    msgThread: object,
    openSuccessDialog: func,
    openErrorDialog: func,
    replyMessage: func,
    sendMessage: func,
    whichForm: string,
  };

  constructor(props) {
    super(props);

    this.state = {
      showReplyFwdMsgForm: false,
      whichForm: undefined,
    };
  }

  // Toggles show/hide when Reply and Forward are clicked
  // We handle this the exact same way for New messages
  // See the /messages/LandingPage.js
  handleMsgFormDisplay = (form) => {
    // let the MessageForm know if Reply or Forward was clicked - this is pulled from MessageThreadButton
    this.setState({
      showReplyFwdMsgForm: !this.state.showReplyFwdMsgForm,
      whichForm: form,
    });
  };

  render() {
    const { msgThread, handleUpdateMessageThread } = this.props;
    const replyFwdFormIsVisible = this.state.showReplyFwdMsgForm;
    const whichForm = this.state.whichForm;

    return (
      <section className={s.component}>
        {!msgThread ? (
          <p className={s.messagePlaceholder}>
            Click a message thread to display its contents here.
          </p>
        ) : (
          <div className={s.container}>
            {!replyFwdFormIsVisible ? (
              <MessageThreadActions
                authenticatedPreferences={this.props.authenticatedPreferences}
                handleMsgFormDisplay={this.handleMsgFormDisplay}
                canReply={msgThread.canReply}
              />
            ) : (
              <MessageForm
                authenticatedPreferences={this.props.authenticatedPreferences}
                closeAlertDialog={this.props.closeAlertDialog}
                forwardMessage={this.props.forwardMessage}
                handleMsgFormDisplay={this.handleMsgFormDisplay}
                handleUpdateMessageThread={handleUpdateMessageThread}
                isLoadingForward={this.props.isLoadingForward}
                isLoadingReply={this.props.isLoadingReply}
                isLoadingSendNew={this.props.isLoadingSendNew}
                openSuccessDialog={this.props.openSuccessDialog}
                openErrorDialog={this.props.openErrorDialog}
                recipients={this.state.recipients}
                replyMessage={this.props.replyMessage}
                sendMessage={this.props.sendMessage}
                thread={msgThread}
                whichForm={whichForm}
              />
            )}
            <MessageThreadList
              thread={msgThread}
              subject={msgThread.subject}
            />
          </div>
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadContainer/MessageThreadContainer.js